module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_7042.b3921d96.png";